import React from 'react'
import styles from "../Modules/footer.module.css";
import { Link } from "react-router-dom";
import { forwardRef } from "react";

const Contact = forwardRef((props,ref) => {
  return (
    <>
    <center ref={ref}>
    <footer className={styles.footer}>
       <div className={styles.footerDisplay}>
            <div>
                <p className={styles.p}><img src="logo.png" alt="fsv logo" width="95"
              height="66" /></p>
                <div className='text-white'>
                Food Supply Vision Ltd <br />&nbsp;&nbsp;&nbsp;&nbsp; Limited Liability Company (LLC) <br /> 
                
                
                </div> <br />
                <ul className={styles.ul}>
                <li className={styles.circledradius1}><a href="https://www.instagram.com/ojaami.com_official?igsh=MW1pdzM0aDJpcG5icQ%3D%3D&utm_source=qr"><span ><i style={{fontSize: '300%',marginTop: '13px',color: 'white'}} class="fa-brands fa-instagram"></i></span></a></li>
                <li className={styles.circledradius}><a href="https://wa.me/+2348165570286"><span><i style={{fontSize: '300%',marginTop: '13px',color: 'white'}} class="fa-brands fa-whatsapp"></i></span></a></li>
               
                </ul>
            </div>
            <div className={styles.locationtext}>
                <p className={styles.p}>Location</p>
                <i style={{fontSize: '120%',color: 'white'}} class="fa-solid fa-location-dot"></i> &nbsp; Ibadan, Oyo State, Nigeria <br /><br />
                <h5 style ={{color:'#008102'}}>Industry</h5> Food Supply Chain (E-commerce, Agriculture, Logistics) 
                
                
            </div>
       </div>
        <div>
          <br />© Copyright 2025 FSV. All Rights Reserved</div> <br />
    </footer>
    </center>
    </>
  )
})

export default Contact;